// extracted by mini-css-extract-plugin
export default {"input_number":"style_input_number__q2Mhl","arrow_up":"style_arrow_up__17rTA","arrow_down":"style_arrow_down__EYeRM","label":"style_label__nFGbv"};